/*------------------------------------*\
    FORM SAVE
\*------------------------------------*/
class FormSave {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        let saveButton = self.elem.querySelector('[data-save-button]');
        let saveButtonBack = self.elem.querySelector('[data-save-button-back]');
        let formAction = self.elem.getAttribute('action');

        self.populateFields();

        // Listen for click event on form save button
        saveButton.addEventListener('click', evt => {
            // Call the saveData() method
            self.saveData();

            // If form is valid...
            if (self.elem.checkValidity()) {
                // Continue to next page
                window.location = formAction;
            }
        });

        if (saveButtonBack) {
            saveButtonBack.addEventListener('click', evt => {
                // Call the saveData() method
                self.saveData();

                // If form is valid...
                if (self.elem.checkValidity()) {
                    // Continue to next page
                    window.location = formAction;
                }
            });
        }
    }

    populateFields() {
        let self = this;

        // Filter out any hidden fields (used for setting defaults for checkbox/radio fields) and loop through
        [...self.elem.elements].filter(field => field.type !== 'hidden').forEach(field => {
            // Get the field's related value from local storage
            let storedValue = localStorage.getItem(field.name);

            // If a value exists in local storage...
            if (storedValue !== null) {
                // Parse the data we get from local storage
                let storedValueObj = JSON.parse(storedValue);

                // If the field is a checkbox or radio input...
                if (field.type === 'checkbox' || field.type === 'radio') {
                    // If the field's value matches what is stored in local storage...
                    if (field.value === storedValueObj.value) {
                        // Check the checkbox/radio
                        field.checked = true;
                    }
                    // Otherwise...
                    else {
                        // Uncheck the checkbox/radio
                        field.checked = false;
                    }
                }
                // If the fields is not a checkbox or radio input...
                else {
                    if (storedValueObj.value.length > 0) {
                        field.value = storedValueObj.value;
                    }
                }
            }
        });
    }

    saveData() {
        let self = this;

        // Loop through the form's fields
        [...self.elem.elements].forEach(field => {

            // If the field is either:
            // a. a checkbox/radio input and it's checked, or
            // b. not a checkbox/radio input
            if (((field.type === 'checkbox' || field.type === 'radio') && field.checked) || (field.type !== 'checkbox' && field.type !== 'radio')) {
                // Add the field's name, label and value to localStorage (JSON stringify the label and value)
                localStorage.setItem(
                    field.name,
                    JSON.stringify({
                        'label': field.getAttribute('data-label'),
                        'value': field.value
                    })
                );
            }
        });

        localStorage.removeItem("");
    }
}

export default FormSave;
